import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-suggested-questions',
  styleUrl: 'biel-suggested-questions.css',
  shadow: true,
})
export class BielSuggestedQuestions {
  @Prop() heading: string = 'Suggested questions';
  @Prop() questions: string[] = [];
  @Prop() bielId: string;

  @Event() suggestedQuestionClick: EventEmitter<{ bielId: string; message: string }>;
  @Event() scrollToBottom: EventEmitter<{ bielId: string }>;

  handleQuestionClick(question: string) {
    this.suggestedQuestionClick.emit({ bielId: this.bielId, message: question });
    this.scrollToBottom.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <div class="biel-suggested-questions" part="container">
        <span class="biel-suggested-questions-title" part="title">
          {this.heading}
        </span>
        <div class="biel-suggested-questions-list" part="list">
          {this.questions.map((question) => (
            <button
              class="biel-suggested-question"
              part="question"
              onClick={() => this.handleQuestionClick(question)}
            >
              {question}
            </button>
          ))}
        </div>
      </div>
    );
  }
}
